import React from "react"
import "./index.css"
import Icon from '../../artzu-ui/src/Icon'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { Link } from 'react-router-dom';

const Header = ({ header, backAction }) => {
  return (
    <div className="my-bookings-head">
      <a href="javascript:void(0)" onClick={backAction}>
        <Icon size="sm" name="BackArrow" color="#414141" />
      </a>
      {header}
      <Link to="/book">
        <FontAwesomeIcon icon={faPlus} style={{fontSize: "21px"}} />
      </Link>
    </div>
  )
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/MyBookings/Header.js